<app-svg-animation
  class='loader'
  [width]="loadingSettings.width"
  [height]="loadingSettings.height"
  [cssClasses]="extraClass"
  [path]="loadingSettings.path"
></app-svg-animation>
